<template>
<v-container fluid>
    <v-row>
        <v-col cols="12">
        <div class="d-flex justify-center">
          <v-subheader class="headline font-weight-bold ">Self Paced Training</v-subheader>
        </div>
        </v-col>

        <v-col v-if="modules.TeacherModule" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'teacherModules', params: { type: 'All' } }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Modules"> </clickable-card>
        </router-link>
      </v-col>

      <!-- <v-col v-if="modules.TeacherSchedule" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'AddTeacherTraining', params: { type: 'All' } }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Schedule Training"> </clickable-card>
        </router-link>
      </v-col> -->

      <v-col v-if="modules.TeacherAssessment" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'teacherAssessment' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-sign-text" color="orange"
            cardTitle="Assessment"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.TeacherTrainingTopics" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'teacherTrainingTopics' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-content-save-all-outline"
            color="orange" cardTitle="Training Topics"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.TeacherEnrollment" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'teacherEnrollment' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-sign-text" color="orange"
            cardTitle="Training Registration"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.TeacherPerformance" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'teacherPerformance' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-sign-text" color="orange"
            cardTitle="Training Performance"> </clickable-card>
        </router-link>
      </v-col>
    </v-row>
</v-container>
</template>

<script>
import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'

export default {

  name: 'selfTraining',
  components: { ClickableCard },
  data () {
    return {
      modules: {
        TeacherModule: this.checkModuleAccess('TeacherModule'),
        TeacherAssessment: this.checkModuleAccess('TeacherAssessment'),
        TeacherTrainingTopics: this.checkModuleAccess('TeacherTrainingTopics'),
        TeacherEnrollment: this.checkModuleAccess('TeacherEnrollment'),
        TeacherPerformance: this.checkModuleAccess('TeacherPerformance'),
        TeacherSchedule: this.checkModuleAccess('TeacherSchedule')
      }
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  },
  async created () {
    console.log(this.modules)
  }

}
</script>
